export default __webpack_public_path__ + "static/media/Path of the Enlightened.d3662250.jpg";